/// <amd-module name="Repos/Views/FilesHub/Components/PreviewContent" />
import * as React from "react";
import { ContentPreview } from "Repos/Files/Components/ContentPreview";
import { ContentPreviewDefaultBehavior, getContentPreviewService } from "Repos/Files/ContentPreview";
import { IGitItem } from "Repos/Files/Contracts";
import * as Resources from "Repos/Views/FilesHub/Resources";
import { IPageStateHistoryService } from "VSS/Features/History";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributedTab } from "VSSUI/Tabs";
import { getFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

registerFilesHubTab({
    getTab: (pageContext: IVssPageContext, item: IGitItem, editMode: boolean) => {
        if (item.isInvalid && !item.isNewItem) {
            return;
        }

        // Get the tab from the service based on the item's extension
        const contentPreviewService = getContentPreviewService(pageContext);
        const previewContribution = contentPreviewService.getPreviewContribution(item.path);
        if (!previewContribution) {
            return;
        }

        const filesHubViewService = getFilesHubViewService(pageContext);

        return {
            id: "preview",
            name: Resources.Preview,
            order: 15,
            render: () => (
                <ContentPreview
                    className="files-hub-content-preview"
                    contributionId={previewContribution.contributionId}
                    contribution={previewContribution}
                    getItemContent={() => filesHubViewService.getItemContent(item.path)}
                    urlTransformer={filesHubViewService.getUrlTransformer(item.path)}
                />
            )
        };
    },
    isDefaultTab: (pageContext: IVssPageContext, item: IGitItem, editMode: boolean, tab: IVssContributedTab, currentTabId: string): boolean => {
        const contentPreviewService = getContentPreviewService(pageContext);
        const previewContribution = contentPreviewService.getPreviewContribution(item.path);
        const historyState = pageContext.getService<IPageStateHistoryService>("IPageStateHistoryService").getProjectedState();

        return (
            !editMode &&
            currentTabId === "" &&
            !!previewContribution &&
            previewContribution.defaultBehavior &&
            !(historyState.line && historyState.lineStartColumn) &&
            (previewContribution.defaultBehavior === ContentPreviewDefaultBehavior.ShowRenderedContent ||
                previewContribution.defaultBehavior.toString() === ContentPreviewDefaultBehavior[ContentPreviewDefaultBehavior.ShowRenderedContent])
        );
    }
});
